import {reqCertificate} from '@/api/certificateApi';

export function printCertificateService(courseId: string) {
  return reqCertificate(courseId);
}
